<script setup lang="ts">
import Loading from '@/components/ui/Loading.vue';
import immersveLogoLight from '@/assets/icons/immersve-logo-light.svg';
// import immersveLogoDark from '@/assets/icons/immersve-logo-dark.svg';
import { computed, ref, onUnmounted } from 'vue';

const logo = computed(() => {
  const isDarkTheme = ref(
    window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  );

  function updateTheme(e: MediaQueryListEvent) {
    isDarkTheme.value = e.matches;
  }

  if (window.matchMedia) {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', updateTheme);
    onUnmounted(() => {
      mediaQuery.removeEventListener('change', updateTheme);
    });
  }
  // TODO: this is hardcoded to light mode, need to fix if we want to add darkmode
  return immersveLogoLight; // isDarkTheme.value ? immersveLogoDark : immersveLogoLight;
});
</script>

<template>
  <div class="flex w-full justify-center">
    <div class="flex h-full w-full flex-col items-center justify-center">
      <div class="container mx-auto px-4">
        <header>
          <div class="mt-4 flex items-baseline justify-between sm:mt-7">
            <!-- Logo container -->
            <div class="w-[153px]">
              <img class="hidden h-9 sm:block" :src="logo" alt="Immersve logo" />
            </div>
          </div>
        </header>
      </div>
      <div class="max-w-xl min-w-80">
        <slot>
          <Loading class="mx-auto mt-10 h-10 w-10" />
        </slot>
      </div>
    </div>
  </div>
</template>
